import React from "react";
import { SelectInputProps } from "@material-ui/core/Select/SelectInput";
import Form from "pages/dashboard/interests-form";
import { ContainerCardLayout } from "components/haven-design";
import { HistoryBackButton, SubmitButton } from "components/buttons";

type Props = {
  listId: string | undefined;
  listName: string;
  interestId: string | undefined;
  handleSubmit: React.FormEventHandler<HTMLFormElement>;
  handleChangeHousehold: SelectInputProps["onChange"]
  validationSchema: any;
  formData: any;
}

const styles: Record<string, React.CSSProperties> = {
  tableContainer: {
    minHeight: 450,
  },
  subheader: {
    boxShadow: `0 0 0 1px rgba(63,63,68,0.02),
                0 1px 3px rgba(63, 63, 68, 0.1),
                0 1px 2px rgba(0,0,0,0.02)`,
    backgroundColor: "white",
    minHeight: 58,
  },
  submitContainer: {
    position: "sticky",
    zIndex: 100,
    left: 0,
    right: 0,
    bottom: 0,
  },
  header: {
    textAlign: "left",
  },
  submitBackground: {
    display: "flex",
    justifyContent: "center",
    background: "white",
    padding: 10,
  },
};

const InterestClientUpdate: React.FC<Props> = (props) => (
  <ContainerCardLayout title={`${props.listName} Application`}>
    <form id="interest-form" onSubmit={props.handleSubmit} style={{ display: "grid" }}>
      <Form
        formData={props.formData}
        handleChangeHousehold={props.handleChangeHousehold}
        validationSchema={props.validationSchema}
      />

      {/* floating submit button*/}
      <div style={styles.submitContainer}>
        <div style={styles.submitBackground}>
          <HistoryBackButton size="L" marginRight text="Cancel" />
          <SubmitButton isWide text="Update and Save"/>
        </div>
      </div>
      {/* END floating submit button*/}
    </form>
  </ContainerCardLayout>
);

export default InterestClientUpdate;
